import Vue from 'vue';
import { PROCESSED } from '../constants/documentStates';

/**
 * showNotification shows an in-app notification to the user
 *
 * @param {Object} [args]
 * @param {string} [args.type] - type of the notification: 'error'|'success'
 * @param {string} [args.group] - group of the notification, which determines placement on screen: 'general'|'api'|'workspace'
 * @param {string} [args.title] - title of the notification
 * @param {string} [args.text] - text of the notification
 * @param {number} [args.duration] - duration of the notification in ms
 */
export function showNotification({
  type = 'error',
  group = 'api',
  title = 'There was an error',
  text = 'Something went wrong, please try again',
  duration = 5000,
} = {}) {
  Vue.notify({
    type,
    group,
    title,
    text,
    duration,
  });
}

export const showDocumentProcessedNotification = (
  documentName,
  url,
  state = PROCESSED,
) => {
  if (notificationsSupported && notificationPermissionsIsGranted()) {
    const title =
      state === PROCESSED
        ? `"${documentName}" has finished processing`
        : `Error processing ${documentName}`;

    const notification = new Notification(title, {
      icon: 'https://local.inscribe.ai/favicon.ico',
    });
    notification.onclick = function () {
      window.parent.focus();
      window.document.location = url;
      notification.close();
    };
  } else if (notificationsSupported) {
    Notification.requestPermission().then((response) => {
      if (response === 'granted') {
        showDocumentProcessedNotification(documentName, url, state);
      }
    });
  }
};

export const notificationsSupported = typeof Notification !== 'undefined';

export const notificationPermissionsIsGranted = () =>
  notificationsSupported && Notification.permission === 'granted';
